export default "__VITE_ASSET__A3hntAS7__"